@if (items().length <= MINIMUM_SLIDER_ITEMS && isDesktop()) {
    <sirius-card-grid
        data-cy="few-cards-component"
        [title]="title()"
        [textHtml]="description() ?? ''"
        [cardSize]="'medium'"
        [items]="items()">
    </sirius-card-grid>
} @else {
    <sirius-card-slider
        data-cy="many-cards-component"
        [title]="title()"
        [textHtml]="description() ?? ''"
        [items]="items()">
    </sirius-card-slider>
}
